import * as PIXI from 'pixi.js'
import { Linear } from 'gsap'
import app from '../app'
import koko from '../koko'
import gsap from 'gsap'
import { TweenLite } from 'gsap/gsap-core'

export class DraggableContainer {
	dragging = false;
	moving = false;
	easing = false;
	content = null;
	contentPos = null;
	mBoundary = null;
	boundary = null;
	//calc
	lastPos = null;
	moveDistance = null;
	boundary = null;
	startPos = null;
	//events
	events = null;
	moveX = true;
	moveY =true;
	xPerc = 0;
	yPerc = 0;
	enabled = false;
	clampMouse = true;
    constructor(content, boundary, events) {
		this.init(content, boundary, events);
	}
	init(content, boundary, events) {
		this.setContent(content);
		this.setBoundary(boundary);

		this.events = events || {};

		this.lastPos = new PIXI.Point(-100000, 0);
		this.moveDistance = new PIXI.Point(0, 0);
		this.startPos = new PIXI.Point(0,0);

		this.calculatePercentages();
    }
	setContent(content) {
		this.content = content;
        this.content.interactive = true;
		this.contentPos = new PIXI.Rectangle(this.content.x, this.content.y, this.content.width, this.content.height);
		return this;
	}
	setBoundary(boundary, dontSetMouseBoundary){
		this.boundary = boundary;
		if(!dontSetMouseBoundary) this.mBoundary = boundary;
		return this;
	}
	setMouseBoundary(mBoundary) {
		this.mBoundary = mBoundary;
	}
	enable(){
		if(this.enabled) return;
		this.enabled = true;

		this.boundStart = function(e){
			this.touchStartHandler.call(this, e);
		}.bind(this);

		this.boundMove = function(e){
			this.pressMoveHandler.call(this, e);
		}.bind(this);

		this.boundEnd = function(e){
			this.touchEndHandler.call(this, e);
		}.bind(this);


        this.content.interactive = true;
		app.stage.interactive = true;

		this.content.on('mousedown', this.boundStart);
		this.content.on('touchstart', this.boundStart);

		app.stage.on('mousemove', this.boundMove);
		app.stage.on('touchmove', this.boundMove);

		this.content.on('mouseup', this.boundEnd);
		this.content.on('mouseupoutside', this.boundEnd);
		this.content.on('touchend', this.boundEnd);
		this.content.on('touchendoutside', this.boundEnd);

		return this;
	}
	eventName = '';
	touchStartHandler(e){
		if(this.easing && this.eventName.length > 0) app.removeUpdateListener(this.eventName);
		this.eventName = 'dragEase'+Math.random();

		//reset lastX
		this.lastPos.x = -100000;
		this.dragging = true;
		this.startPos.x = this.content.position.x;
		this.startPos.y = this.content.position.y;
		if(this.events.start) this.events.start.call(this, this, e);
	}
	pressMoveHandler(e){
		if(!this.dragging) return;
		var local = e.data.getLocalPosition(this.content.parent);
		//first move handler?
		if(this.lastPos.x === -100000) {
			this.lastPos.x = local.x;
			this.lastPos.y = local.y;
		}

		//diff
		this.moveDistance.x = (local.x - this.lastPos.x);
		this.moveDistance.y = (local.y - this.lastPos.y);

		//boom
		if(this.moveX) this.content.position.x = this.content.position.x+this.moveDistance.x;
		if(this.moveY) this.content.position.y = this.content.position.y+this.moveDistance.y;

		if(this.moveX && (this.content.position.x < this.boundary.x || this.content.position.x > this.boundary.x + this.boundary.width)) {
			this.content.position.x = koko.math.clamp(this.content.position.x, this.boundary.x, this.boundary.x + this.boundary.width);
		}


            if(this.moveY && (this.content.position.y < this.boundary.y || this.content.position.y > this.boundary.y + this.boundary.height)) {
                this.content.position.y = koko.math.clamp(this.content.position.y, this.boundary.y, this.boundary.y + this.boundary.height);
            }

		this.contentPos.x = this.content.worldTransform.tx;
		this.contentPos.y = this.content.worldTransform.ty;

		//update it
		if(this.content.width < this.boundary.width) {
			this.clampMouse = true;
		} else {
			this.clampMouse = false;
		}

		if(this.clampMouse) {
			this.lastPos.x = koko.math.clamp(local.x, this.mBoundary.x, this.mBoundary.x + this.mBoundary.width);
			this.lastPos.y = koko.math.clamp(local.y, this.mBoundary.y, this.mBoundary.y + this.mBoundary.height);
		} else {
			this.lastPos.x = local.x;
			this.lastPos.y = local.y;
		}
		if(koko.math.pointDistance(this.startPos, this.content.position) > 5) {
			this.moving = true;
		}

		//update percentages
		this.calculatePercentages();

		//changed
		if(this.events.update) this.events.update.call(this, this, e);
	}
	handleEasing(){
		this.moveDistance.x *= 0.9;
		this.moveDistance.y *= 0.9;

		if(this.moveX) this.content.position.x = this.content.position.x+this.moveDistance.x;
		if(this.moveY) this.content.position.y = this.content.position.y+this.moveDistance.y;

		if(this.moveX && (this.content.position.x < this.boundary.x || this.content.position.x > this.boundary.x + this.boundary.width)) {
			this.content.position.x = koko.math.clamp(this.content.position.x, this.boundary.x, this.boundary.x + this.boundary.width);
		}

		if(this.moveY && (this.content.position.y < this.boundary.y || this.content.position.y > this.boundary.y + this.boundary.height)) {
			this.content.position.y = koko.math.clamp(this.content.position.y, this.boundary.y, this.boundary.y + this.boundary.height);
			this.content.position.y = koko.math.clamp(this.content.position.y, this.boundary.y, this.boundary.y + this.boundary.height);
		}

		//update percentages
		this.calculatePercentages();

		//bazinga
		if(this.events.update) this.events.update.call(this, this);

		if(Math.abs(this.moveDistance.x) < 0.4 && Math.abs(this.moveDistance.y) < 0.4) {
			this.stopEasing();
		}
	}
	stopEasing(e){
		app.removeUpdateListener(this.eventName);
		this.eventName = '';
		if(this.events.complete) this.events.complete.call(this, this, e);
		//stop dragging
		this.lastPos.x = -100000;
		this.dragging = false;
		this.moving = false;
	}
	touchEndHandler(e){
		if(this.easing) {
			this.dragging = false;
			app.addUpdateListener(this.eventName, this.handleEasing.bind(this));
		} else {
			if(this.events.complete) this.events.complete.call(this, this, e);
			//stop dragging
			this.lastPos.x = -100000;
			this.dragging = false;
			this.moving = false;
		}
	}
	disable() {
		if(!this.enabled) return;
		this.enabled = false;

		this.content.off('mousedown', this.boundStart);
		this.content.off('touchstart', this.boundStart);

		app.stage.off('mousemove', this.boundMove);
		app.stage.off('touchmove', this.boundMove);

		this.content.off('mouseup', this.boundEnd);
		this.content.off('mouseupoutside', this.boundEnd);
		this.content.off('touchend', this.boundEnd);
		this.content.off('touchendoutside', this.boundEnd);
		this.content.interactive = false;
		return this;
	}
	calculatePercentages(){
		this.xPerc = (this.content.position.x - this.boundary.x)/this.boundary.width;
		this.yPerc = (this.content.position.y - this.boundary.y)/this.boundary.height;
	}
	setPercX(perc, speed){
		this.percX = perc < 0 ? 0 : perc > 1 ? 1 : perc;
		if(speed !== null) {
			koko.display.animateObject(this.content, speed, { x: this.boundary.x + (this.boundary.width*this.percX) });
		} else{
			this.content.position.x = this.boundary.x + (this.boundary.width*this.percX);
		}
		if(this.easing && this.eventName.length > 0) this.stopEasing();
	}
	setPercY(perc, speed){
		this.percY = perc < 0 ? 0 : perc > 1 ? 1 : perc;
		if(speed !== null) {
			koko.display.animateObject(this.content, speed, { y: this.boundary.y + (this.boundary.height*this.percY) });
		} else{
			this.content.position.y = this.boundary.y + (this.boundary.height*this.percY);
		}

		if(this.easing && this.eventName.length > 0) this.stopEasing();
	}
	constrain(){
		if(this.axis === 'x') {
			if(this.content.x < this.boundary.x) this.content.x = this.boundary.x;
			if(this.content.x > (this.boundary.x+this.boundary.width)) this.content.x = this.boundary.x+this.boundary.width;
		} else {
			if(this.content.y < this.boundary.y) this.content.y = this.boundary.y;
			if(this.content.y > (this.boundary.y+this.boundary.height)) this.content.y = this.boundary.y+this.boundary.height;
		}
	}
}

export class DragSliderContainer extends DraggableContainer {
	snapDistance = 0;
	animTime = 0;
	animEase = 0;
	axis = 'x';
    slideAxis = 'x';
	index = 0;
	evenTiming = true;
	clampMouse = false;
	reverse = false;
	//content, axis, startAxisPoint, slideWidth, slides(total-visible), events
	constructor(content, axis, startPos, slideWidth, slides, events, disableEvenTiming, slideAxis){
		var b = new PIXI.Rectangle(0, 0, 0, 0);
		super(content, b, events);

		this.axis = axis;
		if(slideAxis) this.slideAxis = slideAxis;

		this.snapDistance = slideWidth;
		this.totalSlides = slides;

		this.animTime = 0.1;
		this.animEase = Linear.easeNone;

		this.setBoundaries(startPos, slideWidth, slides,);

		if(disableEvenTiming) this.evenTiming = false;
	}
	setBoundaries(startPos, slideWidth, slides) {

		var draggablePX = slideWidth * slides;
		var min = startPos-draggablePX;
		var max = startPos;

		if(this.axis === 'x') {
			this.boundary.x = min;
			this.boundary.width = max - min;
			this.moveY = false;
		} else {
			this.boundary.y = min;
			this.boundary.height = max - min;
			this.moveX = false;
		}

		//call setBoundary? Expected it on superr, but it's not it's on this
		this.setBoundary(this.boundary);
	}
	animateToPage(index, complete, speed) {
		var pagePosition = this.boundary[this.axis] + this.boundary[this.axis==='x'?'width':'height'] - (this.snapDistance*index);
		var animProperties = {};

		animProperties[this.axis] = pagePosition;
		animProperties.ease = this.animEase;

		animProperties.onComplete = function(){
			this.moving = false;
			if(complete) complete.call(this, this);
		}.bind(this);

		animProperties.onUpdate = function(){
			this.calculatePercentages();
			if(this.events.update) this.events.update.call(this, this);
		}.bind(this);

		var animTime = speed ? speed : this.animTime;

		if(this.evenTiming) {
			//multiple animTime by perctange based on distance away from desired position
			animTime *= Math.abs(this.content.position[this.axis] - pagePosition)/this.snapDistance;
		}

		koko.display.animateObject(this.content, animTime, animProperties);
	}
	touchStartHandler(e){
		super.touchStartHandler.call(this, e);
		gsap.killTweensOf(this.content);
	}
	touchEndHandler(e){
		if(this.snapDistance > 0) {
			this.index = this.totalSlides - Math[this.moveDistance[this.slideAxis] > 0 ? 'ceil' : 'floor'](Math.abs((this.content.position.x - this.boundary.x) / this.snapDistance));
			this.calculatePercentages();
			this.animateToPage(this.index, this.events.complete);
		} else {
			this.moving = false;
			if(this.events.complete) this.events.complete.call(this, this, e);
		}
		//stop dragging
		this.lastPos.x = -100000;
		this.dragging = false;
	}
	gotoSlide(index, speed) {
		this.index = koko.math.clamp(index, 0, this.totalSlides);
		this.calculatePercentages();
		if(speed !== undefined) {
			TweenLite.killTweensOf(this.content);
			this.animateToPage(this.index, this.events.complete || null, speed);
		} else {
			var pos = this.boundary[this.axis] + this.boundary[this.axis==='x'?'width':'height'] - (this.snapDistance*this.index);

			this.content[this.axis] = pos;

			if(this.events.update) this.events.update.call(this, this);
			if(this.events.complete) this.events.complete.call(this, this);
		}
		return this;
	}
	calculatePercentages(){
		this.yPerc = this.xPerc = this.index/this.totalSlides;
		this.indexPerc = (this.content[this.axis] / this.boundary[this.axis]) * this.totalSlides;
	}
	gotoNextSlide(speed) {
		if(this.index < this.totalSlides) {
			this.index++;
			this.gotoSlide(this.index, speed);
		}
		return this;
	}
	gotoPreviousSlide(speed){
		if(this.index > 0) {
			this.index--;
			this.gotoSlide(this.index, speed);
		}
		return this;
	}
	atStart(){
		return this.index === 0;
	}
	atEnd(){
		return this.index === this.totalSlides;
	}
}
